<script lang="ts" setup>
import { useAppBrand } from '@composables/tools/app-brand.hook'

import LinkWhatsApp from '@Widgets/Menu/LinkWhatsApp.vue'
import LinkSendEmail from '@Widgets/Menu/LinkSendEmail.vue'
import LinkSendSms from '@Widgets/Menu/LinkSendSms.vue'

defineOptions({
  name: 'DropdownSupport',
})

const { isSmartestMinds } = useAppBrand()

</script>

<template>
  <LinkWhatsApp v-if="!isSmartestMinds" />
  <LinkSendEmail />
  <LinkSendSms />
</template>
